import React from "react";
import { CheckCircle } from "lucide-react";
import Decorcycle from "./decorcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Grow Your Home Decor & Furnishings Business with WhatsApp",
  points: [
    "Answer questions fast with automated FAQs to speed up sales.",
    "Share your stunning product catalog right on WhatsApp.",
    "Stay connected with customers 24/7 for better engagement.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/home_decor_furnishings/home_decor_furnishings_1.png",
};

const homeDecorServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🏠</span>, // House icon
    title: "Showcase Products with WhatsApp Galleries",
    description: "Share stunning photos of furniture, decor, and designs via WhatsApp. It’s like giving customers a virtual tour of their dream home!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🛋️</span>, // Couch icon
    title: "Simplify Furniture Orders on WhatsApp",
    description: "Let customers browse, order, and track deliveries through WhatsApp. It’s fast, easy, and turns browsers into buyers."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📏</span>, // Ruler icon
    title: "Offer Design Consultations via WhatsApp",
    description: "Help clients plan their spaces with personalized advice and measurements over WhatsApp. It’s a modern way to build trust and close sales."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💡</span>, // Light bulb icon
    title: "Promote Trends with WhatsApp Updates",
    description: "Send the latest home decor trends, seasonal collections, and tips via WhatsApp. Your customers will see you as their go-to style guru."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Schedule Deliveries on WhatsApp",
    description: "Coordinate furniture deliveries and installations easily through WhatsApp. Clients love the transparency and control."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Gather Reviews via WhatsApp",
    description: "Ask for feedback on purchases, services, or designs through WhatsApp. It’s a simple way to improve and showcase your excellence."
  }
];

const homeDecorFAQs = [
  {
    question: "How can WhatsApp boost my home decor sales?",
    answer: "WhatsApp can skyrocket your sales by sharing stunning furniture photos and exclusive deals directly with customers. It’s like giving them a virtual showroom they can explore anytime!"
  },
  {
    question: "Is WhatsApp secure for sharing design plans?",
    answer: "Yes, WhatsApp’s encryption keeps your designs, measurements, and client data safe. It’s like locking your creative ideas in a vault, so you can focus on impressing clients."
  },
  {
    question: "Can customers order furniture on WhatsApp?",
    answer: "Absolutely! They can browse catalogs, place orders, and track deliveries via WhatsApp. It’s like shopping from a design magazine that delivers straight to their door."
  },
  {
    question: "How does WhatsApp help with interior design consultations?",
    answer: "Offer personalized advice, share mood boards, and schedule site visits via WhatsApp. It’s like having a design expert chatting with clients, building trust and sales."
  },
  {
    question: "What decor trends can I promote on WhatsApp?",
    answer: "Share seasonal styles, DIY tips, and new collection launches via WhatsApp. It’s a direct line to keep your audience inspired and ready to refresh their spaces."
  },
  {
    question: "Can WhatsApp manage furniture deliveries?",
    answer: "Yes! Coordinate delivery schedules, send updates, and handle returns through WhatsApp. It’s like having a logistics team that keeps everything on track effortlessly."
  },
  {
    question: "How do customers feel about using WhatsApp for home decor?",
    answer: "They love it! Customers appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making shopping a joy."
  },
  {
    question: "Can WhatsApp reduce my decor business workload?",
    answer: "Definitely! Automate responses to queries and handle orders via WhatsApp, freeing you up for design work. It’s like having an extra hand in the office!"
  },
  {
    question: "How can I gather feedback on WhatsApp for decor?",
    answer: "Send surveys or ask for reviews on purchases and services via WhatsApp. It’s a simple way to improve and showcase your expertise to new clients."
  },
  {
    question: "How do I set up WhatsApp for my home decor business?",
    answer: "Start with WhatsApp Business, create a catalog of products, and train your team to chat professionally. Tools like ChatMitra can help you launch quickly and effectively!"
  },
];

const Homedecor = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Grow Your Home Decor & Furnishings Business with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                 <a
                 key={index}
                 href={button.buttonLink}
                 className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
               >
                 {button.text}
               </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Home Decor Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Boost your home decor sales with WhatsApp’s easy tools. Start today with ChatMitra—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Decorcycle />
      <WhatsAppServices servicesData={homeDecorServices} isVisible={true}/>
      <Faqs faqs={homeDecorFAQs} />
      <Footer />

      <title>Grow Your Home Decor Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Use WhatsApp to grow your home decor & furnishings business. Automate FAQs, share catalogs, and engage customers 24/7 with ChatMitra." />
      <meta name="keywords" content="WhatsApp for home decor, home furnishings marketing, WhatsApp automation, decor sales, customer engagement" />
      <meta property="og:title" content="Grow Your Home Decor Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Promote home decor products, recover carts, and connect with customers using WhatsApp’s powerful features." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-home-decor-and-furnishings" />
      <meta property="og:type" content="website" />
    </>
  );
};

export default Homedecor;
